'use client';

import React from 'react';
import { useSessionStore } from 'app/stores/globalStore';

export default function MainLayout({
  children,
  hideHeader = false,
}: {
  children: React.ReactNode;
  hideHeader?: boolean;
}) {
  const { isMenuOpen } = useSessionStore(state => state);

  if (!hideHeader) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-screen w-full overflow-hidden">
      <main className="flex-1 w-full bg-okron-background">
        <div className={`mr-6 h-full ${isMenuOpen ? 'ml-60' : 'ml-16'}`}>
          {children}
        </div>
      </main>
    </div>
  );
}
